module.exports = "https://cdn.qantashotels.com/qpcustomerui/_next/static/images/logo-f4b9958dd13620477ecd2e38dfb6cc89.svg";